{
  "$id": "wealthlane://forms/role-mapping/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [],
  "observers": [],
  "rules": [
    {
      "id": "roleMappingItemsRequiredOnCreate",
      "target": "#/properties/selectedRoleMappingItems",
      "rule": "required",
      "message": "At least one role mapping must be selected",
      "condition": {
        "meta": "mode",
        "equals": "create"
      }
    }
  ]
}
